
export default defineNuxtPlugin(async (nuxtApp) => {
  const reloadAppConfig = async () => {
    const url = useRequestURL()

    const appConfig = await rawTrpcRequest({ host: url.host },{
      route: 'multiplatform',
      procedure: 'config',
      method: 'GET'
    })

    updateAppConfig(appConfig?.result.data.json as any)
  }

  try {
    await reloadAppConfig()
  } catch (e) {
    showError({
      status: 500,
      statusText: "Failed to load app config",
    })
  }

  return {
    provide: {
      reloadAppConfig
    }
  }
})
